import { render, staticRenderFns } from "./Parameters.vue?vue&type=template&id=1dc60e2e&scoped=true&"
import script from "./Parameters.vue?vue&type=script&lang=js&"
export * from "./Parameters.vue?vue&type=script&lang=js&"
import style0 from "./Parameters.vue?vue&type=style&index=0&id=1dc60e2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc60e2e",
  null
  
)

export default component.exports